import React, { useEffect, useState } from "react";
import { adminContacts } from "../../services/api";
import { Mail } from "lucide-react";

export const AdminContacts = () => {
  const [contacts, setContacts] = useState([]);
  useEffect(() => { adminContacts().then(setContacts).catch(() => {}); }, []);

  if (contacts.length === 0) {
    return <p className="text-ink/50 text-sm bg-white rounded-2xl border border-border p-8 text-center" data-testid="admin-contacts-empty">Keine Kontaktanfragen vorhanden.</p>;
  }
  return (
    <div className="space-y-3" data-testid="admin-contacts">
      {contacts.map((c) => (
        <div key={c.id} className="bg-white rounded-2xl border border-border p-5" data-testid="admin-contact-row">
          <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
            <div className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-wine" />
              <span className="font-semibold text-ink text-sm">{c.name}</span>
              <a href={`mailto:${c.email}`} className="text-sm text-wine hover:underline">{c.email}</a>
            </div>
            <span className="text-xs text-ink/40">{c.created_at ? new Date(c.created_at).toLocaleString("de-CH") : ""}</span>
          </div>
          <p className="text-sm text-ink/70 whitespace-pre-line">{c.message}</p>
        </div>
      ))}
    </div>
  );
};
